function noticeCloser() {
  const noticeForPrice = document.getElementById("noticeForPrice");
  const noticeCloserHandler = document.getElementById("noticeCloser");

  if (!noticeForPrice && !noticeCloserHandler) return;

  noticeCloserHandler.addEventListener("click", () => {
    noticeForPrice.classList.replace("h-9", "h-0");
    noticeForPrice.classList.replace("max-sm:h-12", "max-sm:h-0");

    setTimeout(function () {
      noticeForPrice.remove();
    }, 1000);
  });
}

noticeCloser();
